// Localhost
// const baseUrl = 'http://127.0.0.1:8080/v1';

// Staging
// const baseUrl = 'https://atbcmqtt.aquasense.tech/v1'

// Production
const baseUrl = 'https://gujcomasol.aquakrishi.aquasense.tech/v1';

export default baseUrl;
